import { french as commonFrench } from '~frontend-common/i18n/french';
import { TranslationKeys } from '../english/error.i18n';

export const keys: TranslationKeys = {
  error: {
    invalidCredentials: 'Accès refusé, veuillez vérifier vos identifiants et réessayer.',
    clientNotFound: 'Nous rencontrons des problèmes de connectivité. Veuillez réessayer.',
    clientUnauthorized: 'Nous rencontrons des problèmes de connectivité. Veuillez réessayer.',
    clientRequestInvalid: 'Nous rencontrons des problèmes de connectivité. Veuillez réessayer.',
    serverUnreachable: 'Nous rencontrons des problèmes de connectivité. Veuillez réessayer.',
    serverError: 'Nous rencontrons des problèmes de connectivité. Veuillez réessayer.',
    serverTimeout: 'Nous rencontrons des problèmes de connectivité. Veuillez réessayer.',
    unknownError: 'Nous rencontrons des problèmes de connectivité. Veuillez réessayer.',

    // TODO: this is for the 404 component, needs refactoring and using namespaces
    ...commonFrench.error,
  },
};

export default keys;
